import {
   ReceptionServiceWithPractitioners,
   ReceptionServiceWithPractitionersQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';
import { ServiceLocation, ServiceLocationQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet, useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { receptionServiceTranslationKeys } from '../../../translations';

type PractitionerReceptionServiceUpdateFormLoaderRenderProps = {
   receptionService: ReceptionServiceWithPractitioners;
   serviceLocations: ServiceLocation[];
};

type PractitionerReceptionServiceUpdateFormLoaderProps = {
   readonly practitionerId: number;
   readonly receptionServiceId: ReceptionServiceId;
   readonly children: (renderProps: PractitionerReceptionServiceUpdateFormLoaderRenderProps) => JSX.Element;
};

export const PractitionerReceptionServiceUpdateFormLoader = (
   props: PractitionerReceptionServiceUpdateFormLoaderProps
): JSX.Element => {
   const {
      data: receptionServiceWithPractitioners,
      loading: receptionServiceWithPractitionersLoading,
      error: receptionServiceWithPractitionersError,
   } = useCqrsGet<ReceptionServiceWithPractitioners>(() => {
      const query = new ReceptionServiceWithPractitionersQuery();
      query.id = props.receptionServiceId;
      query.practitionerId = Slot.of(props.practitionerId);
      return query;
   });

   const {
      data: serviceLocations,
      loading: serviceLocationsLoading,
      error: serviceLocationsError,
   } = useCqrsSearch<ServiceLocation>(() => {
      return new ServiceLocationQuery();
   });

   if (receptionServiceWithPractitionersLoading || serviceLocationsLoading) {
      return <LoaderSpinner />;
   }

   if (receptionServiceWithPractitionersError || serviceLocationsError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={receptionServiceTranslationKeys.update.form.errors.loadData}
            displayIndicator
         />
      );
   }

   return props.children({
      receptionService: receptionServiceWithPractitioners,
      serviceLocations: serviceLocations,
   });
};
